import PageHeader from "components/shared/PageHeader";
import { CharacterSerializersCharacterByline } from "types/serializers";
import ReportCharacterButton from "components/ReportDropdown/ReportCharacterButton";
import characterIcon from "icons/duotone/user-tag.svg";

export default function CharacterHeader({ character }: { character: CharacterSerializersCharacterByline }) {
  return (
    <PageHeader
      title={character.name}
      icon={characterIcon}
      description={`${character.name} is a character in ${
        character.booksCount
      } ${character.booksCount === 1 ? "book" : "books"}.`}
    >
      <ReportCharacterButton character={character} />
    </PageHeader>
  );
}